import * as Actions from './SessionPollActions';
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { getSessionPolls } from '../../Apis/ReportingReadApi';
import { forceLoginIfExpired } from '../Utils/RedirectionUtils';

export function* getSessionPollWatcher() {
  yield takeLatest(Actions.GET_SESSION_POLL_REQUEST, getSessionPollWorker);
}

export function* getSessionPollWorker({ payload }) {
  const { sessionKey, webinarKey } = payload;
  let polls = [];
  try {
    const axiosResponse = yield call(getSessionPolls, webinarKey, sessionKey);
    polls = axiosResponse.data;
  } catch (error) {
    yield put({ type: Actions.GET_SESSION_POLL_FAILURE, error });
    forceLoginIfExpired(error);
    return;
  }
  yield put({
    type: Actions.GET_SESSION_POLL_SUCCESS,
    payload: { polls }
  });
}

export default function* rootSaga() {
  yield all([fork(getSessionPollWatcher)]);
}



// WEBPACK FOOTER //
// ./src/Reducks/SessionPoll/SessionPollSagas.js